import styled from '@emotion/styled';

const MakeActionButton = styled.button`
  font-size: 17px;
  font-weight: 500;
  color: white;
  padding: 15px 30px;
  border-radius: 5px;
  text-transform: capitalize;
  background: #211d70;

  &:hover {
    background-color: #3399ff;
  }

  /* SMALL DEVICES (MOBILE, IPAD MINI) */
  @media (max-width: 767px) {
    display: block;
    margin: 0 auto;
  }
`;

export default MakeActionButton;
